import { createAction } from 'redux-actions'
import { browserHistory } from 'react-router'
import VoteService from '../../services/VoteService'
import types from './types'

const service = new VoteService()

export const getVote = createAction(types.VOTE_READ, (pollId) =>
	service.get(pollId)
)

export const castVote = createAction(types.VOTE_CAST, (pollId, option) =>
	service.cast(pollId, option).then(() =>
		browserHistory.push(`/${pollId}/vote/success`)
	)
)



// WEBPACK FOOTER //
// ./src/redux/actions/vote.js